// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__XkaUU","dragIcon":"SortableItem_dragIcon__2Kcyy","disabled":"SortableItem_disabled__uZp_6"};